const STORAGE_KEY = "adminAdvertisements";

function getStorage() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.localStorage;
}

export function readAdvertisements() {
  const storage = getStorage();
  if (!storage) {
    return [];
  }

  try {
    const storedValue = storage.getItem(STORAGE_KEY);
    return storedValue ? JSON.parse(storedValue) : [];
  } catch (error) {
    console.warn("Impossibile leggere le pubblicità memorizzate", error);
    return [];
  }
}

export function saveAdvertisements(advertisements) {
  const storage = getStorage();
  if (!storage) {
    return advertisements;
  }

  storage.setItem(STORAGE_KEY, JSON.stringify(advertisements));
  return advertisements;
}

export function getActiveAdvertisements({ category } = {}) {
  const now = new Date();
  const normalizedCategory = category?.toString().toLowerCase();

  return readAdvertisements().filter((ad) => {
    const isExpired = ad.expirationDate && new Date(ad.expirationDate) < now;
    if (isExpired) {
      return false;
    }

    if (normalizedCategory) {
      return (ad.categories || []).some((item) => item.toLowerCase() === normalizedCategory);
    }

    return true;
  });
}

export function getAdvertisementById(id) {
  return readAdvertisements().find((ad) => ad.id?.toString() === id?.toString());
}

export function upsertAdvertisement(advertisement) {
  const existing = readAdvertisements();

  let updatedList = [];
  if (advertisement.id) {
    updatedList = existing.map((item) => (item.id === advertisement.id ? advertisement : item));
  } else {
    const newAd = { ...advertisement, id: Date.now().toString() };
    updatedList = [...existing, newAd];
  }

  const savedList = saveAdvertisements(updatedList);
  const savedAdvertisement = advertisement.id
    ? advertisement
    : savedList.find((item) => item.id === updatedList[updatedList.length - 1].id);

  return { advertisements: savedList, advertisement: savedAdvertisement };
}

export function deleteAdvertisement(id) {
  const existing = readAdvertisements();
  const updatedList = existing.filter((ad) => ad.id !== id);
  return saveAdvertisements(updatedList);
}
